// document.addEventListener('DOMContentLoaded', () => {
//   const filterForm = document.getElementById('CollectionFiltersForm');
//   if (!filterForm) return;

//   let filterAbortController = null;

//   // --- 1. EVENT DELEGATION (Fixes "One Time Open" Issue) ---
//   // Pure document par listen kar rahe hain taaki re-render hone ke baad bhi button kaam kare
//   document.body.addEventListener('click', (e) => {
//     // Mobile Drawer Toggle
//     if (e.target.closest('.mobile-filter-toggle-btn')) {
//       document.querySelector('.collection-filters-sidebar').classList.add('drawer-open');
//       document.querySelector('.filter-drawer-overlay').classList.add('active');
//     }
    
//     // Close Drawer
//     if (e.target.classList.contains('filter-drawer-overlay')) {
//       document.querySelector('.collection-filters-sidebar').classList.remove('drawer-open');
//       document.querySelector('.filter-drawer-overlay').classList.remove('active');
//     }

//     // Close button
// if (e.target.closest('#MobileFilterCloseBtn')) {

//     document
//       .querySelector('.collection-filters-sidebar')
//       .classList.remove('drawer-open');

//     document
//       .querySelector('.filter-drawer-overlay')
//       .classList.remove('active');
// }

//     // Category View More Toggle
//     const viewMoreBtn = e.target.closest('#CategoryViewMoreBtn');
//     if (viewMoreBtn) {
//       e.preventDefault();
//       const filterBlock = viewMoreBtn.closest('.custom-navigation-categories');
//       const hiddenItems = filterBlock.querySelectorAll('.hidden-category-item');
//       let isExpanded = viewMoreBtn.getAttribute('data-expanded') === 'true';
//       isExpanded = !isExpanded;
//       hiddenItems.forEach(item => item.style.display = isExpanded ? 'block' : 'none');
//       viewMoreBtn.setAttribute('data-expanded', isExpanded ? 'true' : 'false');
//       viewMoreBtn.textContent = isExpanded ? '- View Less' : `+ View More (${viewMoreBtn.getAttribute('data-count')})`;
//     }

//     // Clear All Handler
//     if (e.target.id === 'ClearAllFilters') {
//       e.preventDefault();
//       filterForm.reset();
//       // const rangeMin = filterForm.querySelector('.range-min');
//       // const rangeMax = filterForm.querySelector('.range-max');
//       // if(rangeMin) rangeMin.value = 0;
//       // // if(rangeMax) rangeMax.value = 10;
//       // if(rangeMax) rangeMax.value = 500;

//       // initPriceSliderFramework();

//       const rangeMin = filterForm.querySelector('.range-min');
// const rangeMax = filterForm.querySelector('.range-max');
// const numMin = filterForm.querySelector('.dynamic-min-input');
// const numMax = filterForm.querySelector('.dynamic-max-input');

// if (rangeMin) rangeMin.value = rangeMin.min;
// if (rangeMax) rangeMax.value = rangeMax.max;

// if (numMin) numMin.value = rangeMin ? rangeMin.min : 0;
// if (numMax) numMax.value = rangeMax ? rangeMax.max : 500;

// initPriceSliderFramework();
//       history.pushState({ path: e.target.href }, '', e.target.href);
//       renderFilteredPage();
//     }
//   });

//   // --- 2. SLIDER LOGIC ---
//   function initPriceSliderFramework() {
//     const rangeMinInput = filterForm.querySelector('.range-min');
//     const rangeMaxInput = filterForm.querySelector('.range-max');
//     const numMinInput = filterForm.querySelector('.dynamic-min-input');
//     const numMaxInput = filterForm.querySelector('.dynamic-max-input');
//     const sliderTrack = filterForm.querySelector('.slider-track');

//     if (!rangeMinInput || !rangeMaxInput || !sliderTrack) return;

//     // function updateSliderTrack() {
//     //   const maxLimit = 10.0;
//     //   const percentMin = (parseFloat(rangeMinInput.value) / maxLimit) * 100;
//     //   const percentMax = 100 - ((parseFloat(rangeMaxInput.value) / maxLimit) * 100);
//     //   sliderTrack.style.left = percentMin + "%";
//     //   sliderTrack.style.right = percentMax + "%";
//     // }
    

//     // collection-filter.js ke andar "initPriceSliderFramework" function mein:
// function updateSliderTrack() {
//   const minLimit = parseFloat(rangeMinInput.min) || 0;
//   const maxLimit = parseFloat(rangeMinInput.max) || 500;

//   let minVal = parseFloat(rangeMinInput.value);
//   let maxVal = parseFloat(rangeMaxInput.value);

//   if (minVal > maxVal) {
//     minVal = maxVal;
//     rangeMinInput.value = minVal;
//   }

//   const percentMin = ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
//   const percentMax = ((maxVal - minLimit) / (maxLimit - minLimit)) * 100;

//   sliderTrack.style.left = percentMin + "%";
//   sliderTrack.style.right = (100 - percentMax) + "%";

//   if (numMinInput) numMinInput.value = minVal;
//   if (numMaxInput) numMaxInput.value = maxVal;
// }

//     updateSliderTrack();

//     // Listeners sirf input range ke liye
//     rangeMinInput.oninput = () => {
//   if (parseFloat(rangeMinInput.value) > parseFloat(rangeMaxInput.value)) {
//     rangeMinInput.value = rangeMaxInput.value;
//   }
//   updateSliderTrack();
// };

// rangeMaxInput.oninput = () => {
//   if (parseFloat(rangeMaxInput.value) < parseFloat(rangeMinInput.value)) {
//     rangeMaxInput.value = rangeMinInput.value;
//   }
//   updateSliderTrack();
// };

//     // Sirf change par trigger (Fetch)
//     rangeMinInput.onchange = renderFilteredPage;
//     rangeMaxInput.onchange = renderFilteredPage;
//   }

//   // --- 3. AJAX ENGINE ---
//   // function renderFilteredPage() {
//   //   if (filterAbortController) filterAbortController.abort();
//   //   filterAbortController = new AbortController();
    
//   //   const formData = new FormData(filterForm);
//   //   let searchParams = new URLSearchParams(formData);

//   //   const destinationUrl = window.location.pathname + '?' + searchParams.toString();
//   //   history.pushState({ path: destinationUrl }, '', destinationUrl);

//   //   fetch(destinationUrl, { signal: filterAbortController.signal })
//   //     .then(response => response.text())
//   //     .then(htmlString => {
//   //       const parser = new DOMParser();
//   //       const htmlDoc = parser.parseFromString(htmlString, 'text/html');
//   //       const grid = document.getElementById('ProductGridContainer');
//   //       if (grid) grid.innerHTML = htmlDoc.getElementById('ProductGridContainer').innerHTML;
        
//   //       // Re-bind only UI
//   //       initPriceSliderFramework();
//   //     })
//   //     .catch(err => console.log(err));
//   // }


//   function renderFilteredPage() {
//     if (filterAbortController) filterAbortController.abort();
//     filterAbortController = new AbortController();
    
//     const formData = new FormData(filterForm);
//     let searchParams = new URLSearchParams(formData);

//     // FIX: Check karein agar page 'all-collections' hai
//     let targetUrl = window.location.pathname;
//     if (targetUrl.includes('all-collections')) {
//         targetUrl = '/collections/all'; // Force AJAX to target the collection page
//     }

//     const destinationUrl = targetUrl + '?' + searchParams.toString();
    
//     history.pushState({ path: destinationUrl }, '', destinationUrl);

//     fetch(destinationUrl, { signal: filterAbortController.signal })
//       .then(response => response.text())
//       .then(htmlString => {
//         const parser = new DOMParser();
//         const htmlDoc = parser.parseFromString(htmlString, 'text/html');
        
//         // Update Grid
//         const grid = document.getElementById('ProductGridContainer');
//         const newGrid = htmlDoc.getElementById('ProductGridContainer');
        
//         if (grid && newGrid) {
//             grid.innerHTML = newGrid.innerHTML;
//         }
        
//         initPriceSliderFramework();
//       })
//       .catch(err => console.log(err));
// }
//   initPriceSliderFramework();

//   // Checkbox filters
// filterForm.addEventListener('change', (e) => {

//   if (
//       e.target.matches('.filter-checkbox-input') ||
//       e.target.matches('input[name="filter.v.availability"]') ||
//       e.target.matches('input[type="checkbox"]')
//   ) {
//       renderFilteredPage();
//   }

// });
//   // Ensure this part is in your event listener inside collection-filters.js
// // const viewMoreBtn = e.target.closest('#CategoryViewMoreBtn');
// // if (viewMoreBtn) {
// //   e.preventDefault();
// //   const filterBlock = viewMoreBtn.closest('.custom-navigation-categories');
// //   const hiddenItems = filterBlock.querySelectorAll('.hidden-category-item');
  
// //   let isExpanded = viewMoreBtn.getAttribute('data-expanded') === 'true';
// //   isExpanded = !isExpanded; // Toggle status
  
// //   hiddenItems.forEach(item => {
// //     item.style.display = isExpanded ? 'block' : 'none';
// //   });
  
// //   viewMoreBtn.setAttribute('data-expanded', isExpanded ? 'true' : 'false');
// //   viewMoreBtn.textContent = isExpanded 
// //     ? '- View Less' 
// //     : `+ View More (${viewMoreBtn.getAttribute('data-count')})`;
// // }

// // Pagination AJAX
// const paginationLink = e.target.closest('.pagination a, .pagination-wrapper a');
// if (paginationLink) {
//   e.preventDefault();

//   const url = new URL(paginationLink.href);

//   history.pushState({ path: url.href }, '', url.href);

//   fetch(url.href)
//     .then(response => response.text())
//     .then(htmlString => {
//       const parser = new DOMParser();
//       const htmlDoc = parser.parseFromString(htmlString, 'text/html');

//       const grid = document.getElementById('ProductGridContainer');
//       const newGrid = htmlDoc.getElementById('ProductGridContainer');

//       if (grid && newGrid) {
//         grid.innerHTML = newGrid.innerHTML;
//       }

//       initPriceSliderFramework();
//     });
// }
// });


document.addEventListener('DOMContentLoaded', () => {
  let filterAbortController = null;

  // --- 1. ACCORDION HANDLER ---
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-dropdown-btn]');
    if (btn) {
      e.preventDefault();
      const dropdown = btn.closest('[data-dropdown]');
      const content = dropdown.querySelector('[data-dropdown-content]');
      const isOpen = dropdown.hasAttribute('data-open');

      if (isOpen) {
        dropdown.removeAttribute('data-open');
        content.hidden = true;
      } else {
        dropdown.setAttribute('data-open', '');
        content.hidden = false;
      }
    }
  });

  // --- 2. GLOBAL EVENT DELEGATION (Mobile Drawer & UI Actions) ---
  document.body.addEventListener('click', (e) => {
    // Mobile Drawer Open
    if (e.target.closest('.mobile-filter-toggle-btn') || e.target.closest('#MobileFilterToggleBtn')) {
      const sidebars = document.querySelectorAll('.collection-filters-sidebar');
      const overlay = document.querySelector('.filter-drawer-overlay');
      sidebars.forEach(sidebar => sidebar.classList.add('drawer-open'));
      if (overlay) overlay.classList.add('active');
    }

    // Close Drawer via Overlay
    if (e.target.classList.contains('filter-drawer-overlay')) {
      closeMobileDrawer();
    }

    // Close Button inside Drawer
    const closeBtn = e.target.closest('#MobileFilterCloseBtn');
    if (closeBtn) {
      closeMobileDrawer();
    }

    // Category View More Toggle
    const viewMoreBtn = e.target.closest('#CategoryViewMoreBtn');
    if (viewMoreBtn) {
      e.preventDefault();
      const filterBlock = viewMoreBtn.closest('.custom-navigation-categories');
      if (filterBlock) {
        const hiddenItems = filterBlock.querySelectorAll('.hidden-category-item');
        let isExpanded = viewMoreBtn.getAttribute('data-expanded') === 'true';
        isExpanded = !isExpanded;

        hiddenItems.forEach(item => item.style.display = isExpanded ? 'block' : 'none');
        viewMoreBtn.setAttribute('data-expanded', isExpanded ? 'true' : 'false');
        viewMoreBtn.textContent = isExpanded ? '- View Less' : `+ View More (${viewMoreBtn.getAttribute('data-count')})`;
      }
    }

    // Clear All Filters Handler
    if (e.target.id === 'ClearAllFilters') {
      e.preventDefault();
      const filterForms = document.querySelectorAll('.collection-filters-form');
      filterForms.forEach(filterForm => {
        filterForm.reset();
        const rangeMin = filterForm.querySelector('.range-min');
        const rangeMax = filterForm.querySelector('.range-max');
        const numMin = filterForm.querySelector('.dynamic-min-input');
        const numMax = filterForm.querySelector('.dynamic-max-input');

        if (rangeMin) rangeMin.value = rangeMin.min;
        if (rangeMax) rangeMax.value = rangeMax.max;
        if (numMin) numMin.value = rangeMin ? rangeMin.min : 0;
        if (numMax) numMax.value = rangeMax ? rangeMax.max : 500;
      });

      initAllPriceSliders();
      const clearUrl = e.target.href;
      history.pushState({ path: clearUrl }, '', clearUrl);
      renderFilteredPage();
    }

    // Pagination AJAX Link Handler
    const paginationLink = e.target.closest('.pagination a, .pagination-wrapper a');
    if (paginationLink) {
      e.preventDefault();
      const url = new URL(paginationLink.href);

      history.pushState({ path: url.href }, '', url.href);

      fetch(url.href)
        .then(response => response.text())
        .then(htmlString => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(htmlString, 'text/html');

          const grid = document.getElementById('ProductGridContainer');
          const newGrid = htmlDoc.getElementById('ProductGridContainer');

          if (grid && newGrid) {
            grid.innerHTML = newGrid.innerHTML;
            grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          initAllPriceSliders();
        })
        .catch(err => console.log(err));
    }
  });

  function closeMobileDrawer() {
    const sidebars = document.querySelectorAll('.collection-filters-sidebar');
    const overlay = document.querySelector('.filter-drawer-overlay');
    sidebars.forEach(sidebar => sidebar.classList.remove('drawer-open'));
    if (overlay) overlay.classList.remove('active');
  }

  // --- 3. SLIDER & PRICE RANGE FRAMEWORK ---
  function initPriceSliderFramework(filterForm) {
    if (!filterForm) return;
    const rangeMinInput = filterForm.querySelector('.range-min');
    const rangeMaxInput = filterForm.querySelector('.range-max');
    const numMinInput = filterForm.querySelector('.dynamic-min-input');
    const numMaxInput = filterForm.querySelector('.dynamic-max-input');
    const sliderTrack = filterForm.querySelector('.slider-track');

    if (!rangeMinInput || !rangeMaxInput || !sliderTrack) return;

    function updateSliderTrack() {
      const minLimit = parseFloat(rangeMinInput.min) || 0;
      const maxLimit = parseFloat(rangeMinInput.max) || 500;

      let minVal = parseFloat(rangeMinInput.value);
      let maxVal = parseFloat(rangeMaxInput.value);

      if (minVal > maxVal) {
        minVal = maxVal;
        rangeMinInput.value = minVal;
      }

      const percentMin = ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
      const percentMax = ((maxVal - minLimit) / (maxLimit - minLimit)) * 100;

      sliderTrack.style.left = percentMin + "%";
      sliderTrack.style.right = (100 - percentMax) + "%";

      if (numMinInput) numMinInput.value = minVal;
      if (numMaxInput) numMaxInput.value = maxVal;
    }

    updateSliderTrack();

    rangeMinInput.oninput = () => {
      if (parseFloat(rangeMinInput.value) > parseFloat(rangeMaxInput.value)) {
        rangeMinInput.value = rangeMaxInput.value;
      }
      updateSliderTrack();
    };

    rangeMaxInput.oninput = () => {
      if (parseFloat(rangeMaxInput.value) < parseFloat(rangeMinInput.value)) {
        rangeMaxInput.value = rangeMinInput.value;
      }
      updateSliderTrack();
    };

    rangeMinInput.onchange = renderFilteredPage;
    rangeMaxInput.onchange = renderFilteredPage;
  }

  function initAllPriceSliders() {
    const filterForms = document.querySelectorAll('.collection-filters-form');
    filterForms.forEach(form => initPriceSliderFramework(form));
  }

  // --- 4. AJAX ENGINE FOR FILTERS ---
  function renderFilteredPage() {
    const activeForm = document.querySelector('.collection-filters-sidebar.drawer-open .collection-filters-form') || document.querySelector('.collection-filters-form');
    if (!activeForm) return;

    if (filterAbortController) filterAbortController.abort();
    filterAbortController = new AbortController();

    const formData = new FormData(activeForm);
    let searchParams = new URLSearchParams(formData);

    let targetUrl = window.location.pathname;
    if (targetUrl.includes('all-collections')) {
      targetUrl = '/collections/all';
    }

    const destinationUrl = targetUrl + '?' + searchParams.toString();
    history.pushState({ path: destinationUrl }, '', destinationUrl);

    fetch(destinationUrl, { signal: filterAbortController.signal })
      .then(response => response.text())
      .then(htmlString => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(htmlString, 'text/html');

        const grid = document.getElementById('ProductGridContainer');
        const newGrid = htmlDoc.getElementById('ProductGridContainer');

        if (grid && newGrid) {
          grid.innerHTML = newGrid.innerHTML;
        }
        initAllPriceSliders();
      })
      .catch(err => {
        if (err.name !== 'AbortError') console.log(err);
      });
  }

  // Bind change events to all filter forms
  const filterForms = document.querySelectorAll('.collection-filters-form');
  filterForms.forEach(filterForm => {
    filterForm.addEventListener('change', (e) => {
      if (
        e.target.matches('.filter-checkbox-input') ||
        e.target.matches('input[name="filter.v.availability"]') ||
        e.target.matches('input[type="checkbox"]') ||
        e.target.matches('.filter-price-input') ||
        e.target.matches('.sort-radio-input')
      ) {
        renderFilteredPage();
      }
    });
  });

  // Initial call on page load
  initAllPriceSliders();
});